import { SvgIcon } from "@mui/material";

export default function CNMazIcon() {
    return <SvgIcon width="244.1624mm"
        height="255.4435mm"
        viewBox="0 0 244.1624 255.4435"
    >
        <defs
            id="defs2">
            <clipPath
                clipPathUnits="userSpaceOnUse"
                id="clipPath26">
                <path
                    d="M 0,825.083 H 795.079 V 0 H 0 Z"
                    id="path24" />
            </clipPath>
            <clipPath
                clipPathUnits="userSpaceOnUse"
                id="clipPath42">
                <path
                    d="M 0,825.083 H 795.079 V 0 H 0 Z"
                    id="path40" />
            </clipPath>
        </defs>
        <g
            id="layer1"
            transform="translate(-3.406895,-4.5699198)">
            <g
                id="g18"
                transform="matrix(0.35277777,0,0,-0.35277777,-13.813458,274.28567)">
                <g
                    id="g20">
                    <g
                        id="g22"
                        clipPath="url(#clipPath26)">
                        <g
                            id="g28"
                            transform="translate(429.1526,663.5336)">
                            <path
                                d="M 0,0 C 99.527,0 188.525,-45.028 247.775,-115.808 203.856,10.417 83.846,101.015 -57.343,101.015 c -178.386,0 -322.996,-144.61 -322.996,-322.996 0,-78.86 28.275,-151.106 75.221,-207.189 -11.571,33.256 -17.879,68.975 -17.879,106.173 C -322.997,-144.611 -178.386,0 0,0"
                                style={{ fill: "#129338", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                                id="path30" />
                        </g>
                        <g
                            id="g32"
                            transform="translate(360.5885,141.4718)">
                            <path
                                d="m 0,0 c -99.527,0 -188.525,45.028 -247.775,115.808 43.919,-126.225 163.929,-216.823 305.118,-216.823 178.386,0 322.996,144.61 322.996,322.996 0,78.86 -28.275,151.106 -75.221,207.189 11.571,-33.256 17.879,-68.975 17.879,-106.173 C 322.997,144.611 178.386,0 0,0"
                                style={{ fill: "#293377", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                                id="path34" />
                        </g>
                    </g>
                </g>
                <g
                    id="g36">
                    <g
                        id="g38"
                        clipPath="url(#clipPath42)">
                        <g
                            id="g44"
                            transform="translate(163.3705,677.5491)">
                            <path
                                d="m 0,0 c 307.026,-104 328,-470 328,-470 -67.867,76.931 -192.934,30.741 -328,-17 0,0 180.58,133.456 0,487"
                                style={{ fill: "#cd3434", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                                id="path46" />
                        </g>
                        <g
                            id="g48"
                            transform="translate(327.3706,644.0491)">
                            <path
                                d="m 0,0 c 328,-46.068 328,-487 328,-487 -67.867,76.931 -192.934,47.741 -328,0 0,0 180.58,133.455 0,487"
                                style={{ fill: "#fecc38", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }}
                                id="path50" />
                        </g>
                    </g>
                </g>
            </g>
        </g>

    </SvgIcon>
}